export class UserRejectModalText {
    public static TITLE = 'Reject';
    public static FULL_TITLE = 'Reject Account';
    public static CONTENT =
        'This action will prevent the user accessing Cevo and any other EWA accounts.';
}

export class UserApproveModalText {
    public static ORGANIZATION_NAME_TOKEN = '{organizationName}';

    public static TITLE = 'Approve';
    public static FULL_TITLE = 'EWA Staff To Approve Account';

    public static ORGANIZATION_CREATE_CONTENT = `This action will allow the user to access Cevo and permitted services, and create the company: <span class="font-medium">${this.ORGANIZATION_NAME_TOKEN}</span>`;
    public static ORGANIZATION_ASSIGN_CONTENT = `This action will allow the user to access Cevo and permitted services, and assign the user to: <span class="font-medium">${this.ORGANIZATION_NAME_TOKEN}</span>`;
}
